<template>
  <el-dialog :visible.sync="visible" width="400px" center :show-close="true" :close-on-click-modal="true"
    class="my-custom-dialog">
    <div v-loading="loading">

      <el-tabs v-model="activeTab">
        <el-tab-pane label="密码登录" name="passwordLogin">
          <el-form :model="passwordLoginForm" :rules="passwordLoginRules" ref="passwordLoginForm" label-width="0">
            <el-form-item prop="username">
              <el-input v-model="passwordLoginForm.username" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model="passwordLoginForm.password" show-password placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="rememberPassword">记住密码</el-checkbox>
            </el-form-item>
          </el-form>
         
          
        </el-tab-pane>
        <el-tab-pane label="账号登录" name="login">
          <el-form :model="loginForm" :rules="loginRules" ref="loginForm" label-width="0">
            <el-form-item prop="mobile">
              <el-input v-model="loginForm.mobile" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item prop="code" class="login-code-item">
              <el-input v-model="loginForm.code" placeholder="请输入验证码"></el-input>
              <el-button type="text" @click="getCode(2)" :disabled="!loginForm.mobile" class="code-button">{{
                loginCountdown === 60 || !loginCountdown
                  ? "获取验证码"
                  : `${loginCountdown}秒后重发`
              }}</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="注册新账号" name="register">
          <el-form :model="registerForm" :rules="registerRules" ref="registerForm" label-width="0">
            <el-form-item prop="mobile">
              <el-input v-model="registerForm.mobile" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model="registerForm.password" show-password placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item prop="nickName">
              <el-input v-model="registerForm.nickName" placeholder="请输入昵称"></el-input>
            </el-form-item>
            <el-form-item prop="code" class="login-code-item">
              <el-input v-model="registerForm.code" placeholder="请输入验证码"></el-input>
              <el-button type="text" @click="getCode(1)" :disabled="!registerForm.mobile" class="code-button">{{
                countdown === 60 || !countdown
                  ? "获取验证码"
                  : `${countdown}秒后重发`
              }}</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer" v-if="activeTab === 'login'" >
        <el-button type="primary" @click="submitLogin" @keyup.enter="submitLogin">登录</el-button>
        <!-- <div class="agreement">
          <el-checkbox v-model="agreeProtocol">登录即表示同意</el-checkbox>
          <el-link type="primary" @click="openProtocol">《用户协议》</el-link>
        </div> -->
      </div>
      <div slot="footer" class="dialog-footer" v-if="activeTab === 'passwordLogin'">
        <el-button type="primary" @click="submitPasswordLogin" @keyup.enter="submitPasswordLogin">登录</el-button>
        <!-- <div class="agreement">
          <el-checkbox v-model="agreeProtocol">登录即表示同意</el-checkbox>
          <el-link type="primary" @click="openProtocol">《用户协议》</el-link>
        </div> -->
      </div>
      <div slot="footer" class="dialog-footer" v-if="activeTab === 'register'">
        <el-button type="primary" @click="submitRegister" @keyup.enter="submitRegister">确认注册</el-button>
        <!-- <div class="agreement">
          <el-checkbox v-model="agreeProtocol">注册登录即表示同意</el-checkbox>
          <el-link type="primary" @click="openProtocol">《用户协议》</el-link>
        </div> -->
      </div>
    </div>
    <div slot="footer" class="dialog-footer" v-if="activeTab === 'login'" >
        <!-- <el-button type="primary" @click="submitLogin" @keyup.enter="submitLogin">登录</el-button> -->
        <div class="agreement">
          <el-checkbox v-model="agreeProtocol">登录即表示同意</el-checkbox>
          <el-link type="primary" @click="openProtocol('用户协议',6)">《用户协议》</el-link>
          <el-link type="primary" @click="openProtocol('隐私政策',7)">《隐私政策》</el-link>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" v-if="activeTab === 'passwordLogin'">
        <!-- <el-button type="primary" @click="submitPasswordLogin" @keyup.enter="submitPasswordLogin">登录</el-button> -->
        <div class="agreement">
          <el-checkbox v-model="agreeProtocol">登录即表示同意</el-checkbox>
          <el-link type="primary" @click="openProtocol('用户协议',6)">《用户协议》</el-link>
          <el-link type="primary" @click="openProtocol('隐私政策',7)">《隐私政策》</el-link>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" v-if="activeTab === 'register'">
        <!-- <el-button type="primary" @click="submitRegister" @keyup.enter="submitRegister">确认注册</el-button> -->
        <div class="agreement">
          <el-checkbox v-model="agreeProtocol">注册登录即表示同意</el-checkbox>
          <el-link type="primary" @click="openProtocol('用户协议',6)">《用户协议》</el-link>
          <el-link type="primary" @click="openProtocol('隐私政策',7)">《隐私政策》</el-link>
        </div>
      </div>

  </el-dialog>
</template>

<script>
import { setToken } from "@/utils/auth.js";
export default {
  data() {
    return {
      rememberPassword:false,
      loading: false,
      passwordLoginForm: {
        username: "",
        password: "",
      },
      redirect: '/',
      visible: false, // 控制弹窗显示
      activeTab: "passwordLogin", // 当前激活的选项卡
      loginForm: {
        mobile: "", // 登录手机号
        code: "", // 登录验证码
      },
      loginRules: {
        mobile: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      passwordLoginRules: {
        username: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      registerForm: {
        mobile: "", // 注册手机号
        nickName: "", // 注册昵称
        code: "", // 注册验证码
        password: "",
      },
      registerRules: {
        mobile: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        nickName: [{ required: true, message: "请输入昵称", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      countdown: 0, // 注册验证码倒计时
      loginCountdown: 0, // 登录验证码倒计时
      agreeProtocol: false, // 是否同意用户协议
    };
  },
  created() {
    
    
    if(localStorage.getItem("rememberPassword")&&localStorage.getItem("rememberPhone")){
      this.passwordLoginForm.password=localStorage.getItem("rememberPassword")
      this.passwordLoginForm.username=localStorage.getItem("rememberPhone")
    }
    // this.rememberPassword = localStorage.getItem("rememberPassword") ? true : false;
  },
  methods: {
    submitPasswordLogin() {
      // 检查是否同意用户协议
      if (!this.agreeProtocol) {
        return this.$message.error("请先阅读并同意用户协议");
      }
      const phoneReg = /^1[1-9]\d{9}$/;
      const phoneNumber = this.passwordLoginForm.username;
      console.log('phoneReg.test(phoneNumber)', phoneReg.test(phoneNumber))
      if (!phoneReg.test(phoneNumber)) {
          return this.$message.error("请输入正确的手机号");
      }
      this.$refs.passwordLoginForm.validate((valid) => {
        if (valid) {
          this.loading = true

          this.$store
            .dispatch("callInterface", {
              url: "/portal/login",
              data: this.passwordLoginForm,
              method: "post",
            })
            .then((res) => {
              if (res.code === 200) {
                // 登录逻辑
                this.$message.success("登录成功");
                // console.log(res, "res---");
                // return false;
                setToken(res.token);
                if(this.rememberPassword){
                 localStorage.setItem("rememberPassword", this.passwordLoginForm.password);
                 localStorage.setItem("rememberPhone", this.passwordLoginForm.username);
                }
                this.visible = false;
                // 立即刷新当前页面
                // this.$router.go(0);
                this.get_roles()
                this.loading = false

              } else {
                this.loading = false
              }
            })
            .catch((err) => {
              this.$message.error(err);
              this.loading = false

            });
        } else {
          this.$message.error("请填写完整信息");
          this.loading = false

        }
      });
    },
    getCode(type) {
      // 根据类型判断使用哪个倒计时
      const isLogin = type === 2;
      const seconds = isLogin ? this.loginCountdown : this.countdown;
      if (seconds > 0 && seconds < 60) return;

      // 设置对应的倒计时
      if (isLogin) {
        this.loginCountdown = 60;
      } else {
        this.countdown = 60;
      }

      this.$store
        .dispatch("callInterface", {
          url: "/officialweb/useract/sms/code",
          params: {
            phone: isLogin ? this.loginForm.mobile : this.registerForm.mobile,
            type: type,
          },
          method: "get",
        }).then((res) => {
          console.log(res, "发送");
          if (res.code === 200) {
            this.$message.success("验证码已发送");
            // 根据类型开始不同的倒计时
            this.startCountdown(isLogin);
          }else{
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
            this.$message.error(err);
          
        });
    },
    startCountdown(isLogin) {
      const interval = setInterval(() => {
        if (isLogin) {
          if (this.loginCountdown > 0) {
            this.loginCountdown--;
          } else {
            clearInterval(interval);
          }
        } else {
          if (this.countdown > 0) {
            this.countdown--;
          } else {
            clearInterval(interval);
          }
        }
      }, 1000);
    },
    submitLogin() {
      if (!this.agreeProtocol) {
        return this.$message.error("先请阅读和同意用户协议");
      }
      const phoneReg = /^1[1-9]\d{9}$/;
      const phoneNumber = this.loginForm.mobile;
      console.log('phoneReg.test(phoneNumber)', phoneReg.test(phoneNumber))
      if (!phoneReg.test(phoneNumber)) {
        return this.$message.error("请输入正确的手机号");
      }



      const params = {
        code: this.loginForm.code,
        phone: this.loginForm.mobile,
      };
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true

          this.$store
            .dispatch("callInterface", {
              url: "/portal/login/phone",
              data: params,
              method: "post",
            })
            .then((res) => {
              if (res.code === 200) {
                // 登录逻辑
                this.$message.success("登录成功");
                setToken(res.token);
                this.visible = false;
                // 立即刷新当前页面
                // this.$router.go(0);
                this.get_roles()
                
              } else {
                this.loading = false
              }
            });
        } else {
          this.loading = false

          this.$message.error("请填写完整信息");
        }
      });
    },
    submitRegister() {
      if (!this.agreeProtocol) {
        return this.$message.error("先请阅读和同意用户协议");
      }
      this.$refs.registerForm.validate((valid) => {
        const { code, mobile, password, nickName } = this.registerForm || {};
        const params = {
          code,
          username: mobile,
          password,
          nickName,
        };
        if (valid) {
          this.$store
            .dispatch("callInterface", {
              url: "/register",
              data: params,
              method: "POST",
            })
            .then((res) => {
              if (res.code === 200) {
                this.$message.success("注册成功, 现在可以登录了");
              }else{
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              this.$message.error(err);
            });
        } else {
          this.$message.warning("有未填的数据");
        }
      });
    },
    openProtocol(type,id) {
      // 打开用户协议页面/#/footerType?id=3&name=版权说明
      window.open(`/footerType?id=${id}&name=${type}`, "_blank");
    },
    // 获取用户信息跳转
    get_roles() {
      this.$store
        .dispatch("callInterface", {
          url: "/system/user/profile/roles",
          method: "get",
        })
        .then((res) => {
          if (res.code === 200) {
            this.roles = res.data;
            // TODO: 处理角色信息
            if (res.data.some((a) => a.roleKey === "health_merchant")) {
              this.$router.push({
                path: '/personal',
                query: {
                  type: 'merchantProfile',
                }
              })
            } else {
              console.log('this.$router.history',this.$router.history)
              // this.$router.go(0);
              if(this.$route.matched.length>1){
                this.$router.back()
              }else{
                 this.$router.push({
                path: '/personal',
                query: {
                  type: '',
                }
              })
              }

            }

          }
        })
        .catch((err) => {
          console.error("获取角色信息失败:", err);
        });
    },
  },
};
</script>
<style lang="scss">
.my-custom-dialog {
  .el-tabs--border-card>.el-tabs__content {
    padding: 0;
  }

  .el-tabs__nav {
    #tab-login.is-active~.el-tabs__active-bar {
      transform: translateX(60px);
    }

    #tab-register.is-active~.el-tabs__active-bar {
      transform: translateX(255px);
    }
  }

  .el-tabs__item.is-active {
    color: #222;
    font-weight: bold;
  }

  .el-form-item__content {
    display: flex;
  }

  .el-form .el-form-item {
    margin-bottom: 20px;
    border-bottom: 1px solid #eee;
  }

  .el-tabs--border-card {
    box-shadow: none;
  }

  .el-dialog {
    border-radius: 8px;

    .el-dialog__header {
      // display: none;
    }
  }

  .el-tabs {
    border: none;

    .el-tabs__nav-wrap::after {
      width: 0;
    }

    .el-tabs__active-bar {
      height: 4px;
      width: 8% !important;
      margin-left: 9%;
    }

    .el-tabs__header {
      margin-bottom: 30px;
    }

    .el-tabs__nav {
      width: 100%;
      display: flex;

      .el-tabs__item {
        width: 50%;
        text-align: center;
        font-size: 16px;
        color: #222;
      }
    }
  }

  .el-form {
    padding: 0 20px;

    .el-form-item {
      margin-bottom: 20px;
    }
  }

  .el-input__inner {
    width: auto;
    border: none !important;
    // border-bottom: 1px solid #eee !important;
    border-radius: 0px;
  }

  .el-button--primary {
    width: 100%;
  }

  .agreement {
    margin-top: 0px;
    text-align: center;
    font-size: 14px;
    color: #666;
    padding: 15px 20px 15px;
    background: #f1f2f8;

    .el-checkbox {
      margin-right: 4px;
    }

    .el-link {
      font-weight: normal;
      vertical-align: 0px;
    }
  }

  .el-dialog__footer {
    .el-button--primary {
      width: 81%;
      margin-bottom: 40px;
    }

    padding: 0;
  }

  // ... 其他样式保持
}
</style>
<style lang="scss" scoped src="./style/h5_LoginDialog.scss"></style>
